import { useQuery } from '@tanstack/react-query';

import SalaryReconciliationsApiHandler from 'app/services/salaryReconciliationsApiHandler';

import { ListPage } from 'app/types/reconciliations';
import {
  SalaryReconciliationIndividualsRequest,
  SalaryReconciliationUncheckedIndividual,
} from 'app/types/salaryReconciliations';

export const SALARY_UNCHECKED_INDIVIDUALS_QUERY_KEY = 'fetchSalaryUncheckedIndividuals';

/** Lists the individuals a salary accrual reconciliation run could not check, and why. */
const useFetchSalaryUncheckedIndividuals = (
  { id, companyId, page, size }: SalaryReconciliationIndividualsRequest,
  enabled = true
) =>
  useQuery<ListPage<SalaryReconciliationUncheckedIndividual>, Error>(
    [SALARY_UNCHECKED_INDIVIDUALS_QUERY_KEY, id, companyId, page, size],
    () => SalaryReconciliationsApiHandler.listUncheckedIndividuals({ id, companyId, page, size }),
    { enabled: enabled && !!id, keepPreviousData: true }
  );

export default useFetchSalaryUncheckedIndividuals;
